import {DELETE_ATTACHMENT} from "../../../enums/Request/request.types";

export const deleteAttachmentAction = (id) => {
    return {
        type: DELETE_ATTACHMENT,
        payload: id,
    };
};
